import { useNavigate } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";

import Alert from "../../components/Alert";
import { Auth } from "aws-amplify";
import { authState } from "../../state/atoms";
import { useRecoilState } from "recoil";
import { ReactSVG } from "react-svg";

const emailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export default function ForgotPassword() {
  const [auth]: any = useRecoilState(authState);
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  // redirect to inbox if user is already logged in
  useEffect(() => {
    if (auth) {
      navigate("/inbox");
    }
  }, [auth, navigate]);

  const onEmailChange = (event: any) => {
    const target = event.target as HTMLInputElement;
    setEmail(target.value);
  };

  const validateForm = () => {
    return emailRegex.test(email.toLowerCase());
  };

  const handleSubmit = useCallback(
    async (event: any) => {
      setLoading(true);
      console.log("event", event);
      if (event.currentTarget.checkValidity()) {
        event.preventDefault();
        event.stopPropagation();
        try {
          console.log("email", email);
          const result = await Auth.forgotPassword(email);
          console.log(result);

          // // console.log("loginResult", loginResult);
          // const userInfo: any = await Auth.currentUserInfo();
          // console.log("setAuth(userInfo)", userInfo);
          // setAuth(userInfo);
          setSuccessMessage(
            "Password reset email sent! Check your email for instructions."
          );
          setErrorMessage("");

          // navigate("/inbox");
        } catch (e: any) {
          console.error("e", e);
          setErrorMessage(e.message || "An unknown error occurred");
          setSuccessMessage("");
          // show error
        } finally {
          setLoading(false);
        }
      }
    },
    [email]
  );

  return (
    <div>
      <div className="bg-blue flex flex-col justify-center py-48 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <ReactSVG src={'assets/mvsf-logo-white.svg'} className="w-[300px] m-auto" />
          <h2 className="mt-6 text-center text-3xl font-extrabold text-white">
            Reset Your Password
          </h2>
          <p className="mt-2 text-center text-sm text-gray-200">
            Or{" "}
            <a
              href="https://nationalcompassion.org/contact-us/"
              target="_blank"
              rel="noreferrer"
              className="font-medium text-green-500 hover:no-underline hover:text-green-400 underline"
            >
              contact us for help.
            </a>
          </p>
        </div>
        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md drop-shadow-2xl">
          <div className="bg-gray-50 py-8 px-4 shadow sm:rounded-lg sm:px-10">
            <form
              className="space-y-6"
              noValidate
              onSubmit={handleSubmit}
              method="POST"
            >
              <div>
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-gray-700"
                >
                  Email Address
                </label>
                <div className="mt-1">
                  <input
                    id="email"
                    name="email"
                    type="email"
                    autoComplete="email"
                    onChange={onEmailChange}
                    required
                    disabled={loading}
                    className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-green-500 focus:border-green-500 sm:text-sm"
                  />
                </div>
              </div>

              <div>
                <button
                  type="submit"
                  disabled={loading || !validateForm()}
                  className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-gradient-to-b from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 hover:border-green-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 disabled:opacity-75 disabled:from-gray-200 disabled:to-gray-300 disabled:border-gray-300 disabled:cursor-not-allowed transition-all duration-300 ease-in-out mb-4"
                >
                  {loading ? (
                    <>
                      <svg
                        className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                      </svg>
                      <span className="text-white">Processing...</span>
                    </>
                  ) : (
                    <span className="text-white">Reset Password</span>
                  )}
                </button>
              </div>
            </form>
            <div className="mb-4">
              {" "}
              {successMessage ? (
                <Alert title={successMessage} type="success" />
              ) : null}
              {errorMessage ? (
                <Alert
                  title="Reset Password Failed"
                  type="error"
                  message={errorMessage}
                />
              ) : null}
            </div>
            <div className="text-sm text-center">
              <button
                onClick={() => {
                  navigate("/");
                }}
                className="underline font-medium text-green-500 hover:text-green-400 hover:no-underline"
              >
                Return to Login
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
